<template>
    <div class="md-blog-article empty-blog">
        <img-box
            class="empty-blog"
            src="https://cdn.chime.me/image/fs/sitebuild/site-cms/empty-blog.png"
            :alt="$t('md-blog-list.noBlog')"
        ></img-box>
        <p class="empty-text">{{ $t('md-blog-list.comingSoon') }}</p>
    </div>
</template>

<script>
export default {
    i18next: {
        ns: 'md-blog-list'
    },
    name: 'empty-blog'
};
</script>

<style lang="scss">
@import '@/theme/media.scss';

.md-blog-article.empty-blog {
    padding: 130px 0 50px;
    flex-direction: column;
    align-items: center;
    display: flex;
    .empty-blog {
        width: 340px;
        height: 156px;
    }
    .empty-text {
        padding-top: 40px;
        font-family: var(--font-bold);
        font-size: 24px;
        line-height: 26px;
        letter-spacing: 1.3px;
        color: #4a4a60;
    }
    @include media-600 {
        padding: 60px 0 40px;
    }
}
</style>
